import { WidgetName } from '@wix/bookings-services-preferences-modal/types';
import { Preset } from '../types/types';

export const isCalendarPage = (preset: Preset) =>
  preset === Preset.CALENDAR_PAGE;

export const isWeeklyTimeTableWidget = (preset: Preset) =>
  preset === Preset.WEEKLY_TIMETABLE_WIDGET;

export const isCalendarWidget = (preset: Preset) =>
  preset === Preset.CALENDAR_WIDGET;

export const isDailyAgendaWidget = (preset: Preset) =>
  preset === Preset.DAILY_AGENDA_WIDGET;

export const mapPresetToWidgetName = (preset: Preset): WidgetName => {
  switch (preset) {
    case Preset.CALENDAR_PAGE:
      return 'calendar_page';
    case Preset.WEEKLY_TIMETABLE_WIDGET:
      return 'weekly_timetable';
    case Preset.CALENDAR_WIDGET:
      return 'calendar_widget';
    case Preset.DAILY_AGENDA_WIDGET:
      return 'daily_agenda';
  }
};
